import * as React from "react";
import './Select.css';

const inputMainProps = ['required', 'name', 'value', 'onChange', 'placeholder'];

function Select(props) {

    const getMainProps = (elementProps) => {
        const result = {};
        Object.entries(props).forEach(([propName, value]) => {
            (elementProps.indexOf(propName) !== -1) && (result[propName] = value);
        });
        return result;
    }

    const handleChange = (e) => {
        props.onChange(null, e.target.name, e.target.value);
    }

    const getOptions = () => {
        const options = props.options;
        if (props.emptyOption) {
            options.unshift({value: null, label: ''});
        }
        return React.Children.toArray(options.map(opt => <option value={opt.value}>{opt.label}</option>));
    }

    const disabled = props.disabled || false;

    return (
        <div className="FormInput FormSelect">
            <label className={props.required ? 'required-label' : ''}>{props.label}</label>
            <select {...getMainProps(inputMainProps)} onChange={handleChange} disabled={disabled}>
                {getOptions()}
            </select>
        </div>
    );
}

export default Select;